import { initAutoLc } from '@/locales/ko/views/worker_allocate';
import { sortLocale, sortNumber, } from '@/utils/sort';
import DataTableHeaderConverter from '../DataTableHeaderConverter';
const lc = initAutoLc('worker_list_table_header.');
const lcWorkerOrder = initAutoLc('worker_order_list_table_header.');
/** 라이더 리스트 */
const workerAllocateTableHeader = [
    /** 허브명 */
    {
        title: lc('hub_name'),
        value: 'hubName',
        align: 'center',
        width: 150,
        sortable: true,
        sortLogic: sortLocale,
    },
    /** 라이더 코드 */
    {
        title: lc('worker_code'),
        align: 'center',
        width: 100,
        sortLogic: sortLocale,
    },
    /** 라이더 사번 */
    {
        title: lc('worker_number'),
        value: 'workerNumber',
        align: 'center',
        width: 120,
    },
    /** 라이더명 */
    {
        title: lc('worker_name'),
        value: 'workerName',
        align: 'center',
        sortable: true,
    },
    /** 상태 */
    {
        title: lc('status'),
        value: 'status',
        align: 'center',
        width: 80,
        sortable: true,
    },
    // /** 단말기 */
    // {
    //   title: lc('mobile_number'),
    //   value: 'mobile_number',
    //   align: 'center',
    //   width: 140,
    // },
    /** 연락처 */
    {
        title: lc('contact'),
        value: 'workerPhoneWithHyphen',
        align: 'center',
        width: 160,
    },
    // /** 위치 */
    // {
    //   title: lc('location'),
    //   value: 'location',
    //   align: 'center',
    // },
    /** 고객과거리 */
    {
        title: lc('distance_customer'),
        value: 'distanceCustomer',
        align: 'center',
        width: 100,
        sortable: true,
        sortLogic: sortNumber,
    },
    /** 가맹점과거리 */
    {
        title: lc('distance_store'),
        value: 'getDistanceFromPickupWithKm',
        align: 'center',
        width: 100,
        sortable: true,
        sortLogic: sortNumber,
    },
    /** 차단여부 */
    {
        title: lc('block'),
        value: 'isDeniedStore',
        align: 'center',
        width: 80,
        sortable: true,
        sortLogic: sortLocale,
    },
];
export const workerAllocateTableHeaderData = new DataTableHeaderConverter(workerAllocateTableHeader);
/** 라이더 조회 배차 > 대상 주문 */
export const workerAllocateTargetOrderHeader = [
    // {
    //   title: '주문아이디',
    //   align: 'center',
    //   width: 100,
    // },
    {
        title: '당일번호',
        align: 'center',
        width: 80,
    },
    {
        title: '상점명',
        align: 'center',
        width: 120,
    },
    {
        title: '오더상태',
        align: 'center',
        width: 80,
    },
    {
        title: '경과시간',
        align: 'center',
        width: 130,
    },
    {
        title: '남은시간',
        align: 'center',
        width: 130,
    },
    {
        title: '픽업예상시간',
        align: 'center',
        width: 100,
    },
    {
        title: '배달거리',
        align: 'center',
        width: 80,
    },
    {
        title: '출발지',
        align: 'center',
    },
    {
        title: '도착지',
        align: 'center',
    },
];
// 라이더 수행 상황 리스트 테이블
export const workerOrderListTableHeader = [
    /** 주문 아이디 */
    // {
    //   title: lcWorkerOrder('order_id'),
    //   value: 'orderId',
    //   align: 'center',
    //   width: 100,
    // },
    /** 당일번호 */
    {
        title: '당일번호',
        value: 'todayNumber',
        align: 'center',
        width: 80,
    },
    {
        title: '상점명',
        value: 'storeName',
        align: 'center',
        width: 120,
    },
    /** 오더상태 */
    {
        title: lcWorkerOrder('status_code'),
        value: 'stautsCode',
        align: 'center',
        width: 80,
    },
    /** 경과시간(분) */
    {
        title: lcWorkerOrder('elapsed_time'),
        value: 'workerCode',
        align: 'center',
        width: 130,
    },
    /** 남은시간(분) */
    {
        title: lcWorkerOrder('remaining_time'),
        value: 'remainingTime',
        align: 'center',
        width: 130,
    },
    /** 픽업예정시각 */
    {
        title: lcWorkerOrder('pickup_expected_at'),
        value: 'pickupExpectedAt',
        align: 'center',
        width: 100,
    },
    /** 배차시각 */
    {
        title: lcWorkerOrder('allocated_time'),
        value: 'allocatedTime',
        align: 'center',
        width: 80,
    },
    /** 출발지 */
    {
        title: lcWorkerOrder('store_address'),
        value: 'storeAddress',
        align: 'center',
    },
    /** 도착지 */
    {
        title: lcWorkerOrder('drop_address'),
        value: 'dropAddress',
        align: 'center',
    },
];
